<template>
  <div>
    <ValidationObserver
      ref="formType"
    >
      <form
        role="form"
        novalidate
        @submit.prevent
      >
        <BRow>

          <BCol
            cols="12"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="document_type"
              name="document type"
              rules="required"
            >
              <BFormGroup
                label="Document Type"
                label-for="fDocumentType"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <VSelect
                  v-model="selected.documentType"
                  input-id="fDocumentType"
                  placeholder="select document type here"
                  label="name"
                  clearable
                  append-to-body
                  :options="filteredDocumentTypes"
                  :loading="(fetching.documentTypes)"
                  :disabled="(state.busy)"
                  :calculate-position="calculateDropPosition"
                  :class="{ 'is-invalid': errors.length > 0 }"
                >
                  <template #option="{ name }">
                    <div
                      class="text-break text-wrap"
                      v-text="name"
                    />
                  </template>
                  <template #selected-option="{ name }">
                    <div
                      class="w-200px w-md-400px text-truncate"
                      v-text="name"
                    />
                  </template>
                  <template #no-options="">
                    no available document types
                  </template>
                </VSelect>
                <div
                  v-if="errors.length > 0"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <ValidationProvider
              v-slot="{ errors }"
              name="upload limit"
              vid="upload_limit"
              rules="required|max_value:10"
            >
              <BFormGroup
                label="Upload Limit"
                label-for="fUploadLimit"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="fUploadLimit"
                  v-model="formType.upload_limit"
                  type="number"
                  max="10"
                  min="1"
                  autocomplete="off"
                  placeholder="enter upload limit here"
                  class="text-right"
                  :state="errors.length > 0 ? false : null"
                />
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="required"
              name="required"
              rules="required"
            >
              <BFormGroup
                label="Is Required?"
                label-for="fIsRequired"
                :label-class="`font-weight-bolder text-${Number(formType.required) === 1? 'primary' : 'danger'}`"
                class="mb-2"
              >
                <BFormSelect
                  id="fIsRequired"
                  v-model="formType.required"
                  :options="options.yesOrNos"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy"
                >
                  <template #first>
                    <BFormSelectOption
                      value=""
                      disabled
                      v-text="' - - select here - - '"
                    />
                  </template>
                </BFormSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>
        </BRow>
      </form>
    </ValidationObserver>

    <div>
      <BButton
        size="sm"
        variant="primary"
        @click.prevent="validateDocumentType"
      >
        Add
      </BButton>
    </div>

    <div>
      <BTable
        class="mt-2"
        :items="tableTypes.rows"
        :fields="tableTypes.fields"
        :sort-by.sync="tableTypes.sortBy"
        :sort-desc.sync="tableTypes.sortDesc"
        :sort-direction="tableTypes.sortDirection"
        show-empty
      >
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <template #cell(action)="{ index }">
          <BButton
            size="sm"
            variant="danger"
            @click.prevent="() => tableTypes.rows.splice(index, 1)"
          >
            Remove
          </BButton>
        </template>
      </BTable>
    </div>
  </div>
</template>
<script>
import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'

import { filter, find } from 'lodash'

export default {
  name: 'DocumentTypes',

  mixins: [
    MxMisc,
    MxFormatter
  ],

  props: {
    documents: {
      type: Array,
      default: () => []
    }
  },

  emits: [
    'updated:documents'
  ],

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      fetching: {
        documentTypes: false
      },
      options: {
        documentTypes: [
          { id: 1, name: 'Picture with the Customer' },
          { id: 2, name: 'Picture of the Customer Memo ( Signed / Unsigned )' }
          // { id: 3, name: 'Picture of the Commercial Trading Terms ( Signed / Unsigned )' },
          // { id: 4, name: 'Picture of the Business Plan Agreements ( Signed / Unsigned )' }
        ],
        yesOrNos: [
          { value: 1, text: 'Yes' },
          { value: 0, text: 'No' }
        ]
      },
      selected: {
        role: null,
        documentType: null
      },
      formType: {
        id: '',
        document_type_name: '',
        upload_limit: 3,
        required: 1
      },
      tableTypes: {
        rows: this.documents || [],
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        stacked: 'sm',
        fields: [
          { mobile: 0, key: 'index', label: '#' },
          { mobile: 1, key: 'action' },
          { mobile: 2, key: 'document_type_name', label: 'Document Type' },
          { mobile: 3, key: 'upload_limit', label: 'Upload Limit' },
          { mobile: 4, key: 'required', label: 'Is Required?', formatter: this.yesOrNo }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    filteredDocumentTypes () {
      return filter(this.options.documentTypes, documentType => {
        return !this.tableTypes.rows.some(row => row.id === documentType.id)
      })
    }
  },

  watch: {
    'selected.documentType' (documentType) {
      this.formType = Object.assign(this.formType, {
        id: documentType?.id || '',
        document_type_name: documentType?.name || ''
      })
    },
    'documents' (documents) {
      this.tableTypes.rows = documents || []
    }
  },

  methods: {

    validateDocumentType () {
      return this.$refs.formType.validate().then(
        validType => {
          if (!validType) {
            return this.swalInvalid()
          }

          const documentType = find(this.tableTypes.rows, {
            id: Number(this.formType.id)
          })

          if (!documentType) {
            this.tableTypes.rows.push({
              ...this.formType
            })
          }

          this.formType = {
            id: '',
            document_type_name: '',
            upload_limit: 3,
            required: 1
          }

          this.selected.documentType = null

          this.$emit('updated:documents', this.tableTypes.rows)

          this.$refs.formType.reset()
        }
      )
    }
  }
}
</script>
